(function($) {
    $.fn.freeTextSearch = function($searchForm, successFn) {
        var $searchInput = $searchForm.find('input');
        var typingTimer;
        var doneTypingInterval = 1000;
        var activeClass = 'searching';

        $searchForm.on('submit', function(e) {
            e.preventDefault();
        });

        $searchInput.on('input', function(e) {
            e.preventDefault();
            clearTimeout(typingTimer);

            if ($searchInput.val() === '') {
                $searchForm.removeClass(activeClass);
            } else {
                typingTimer = setTimeout(doneTyping, doneTypingInterval);
                $searchForm.addClass(activeClass);
            }
        });

        function doneTyping() {
            successFn();
        }
    };
}(jQuery));



// WEBPACK FOOTER //
// ./library/js/plugins/free-text-search.js